import { Skeleton } from '@/components/UI/Skeleton'

export function RewardOverviewSkeleton() {
  return (
    <div className="flex items-start gap-3 px-4 py-3">
      {/* サムネイル */}
      <Skeleton variant="rect" width={100} height={100} className="shrink-0 rounded-[16px]" />

      {/* テキスト情報 */}
      <div className="min-w-0 flex-1 pt-1">
        <Skeleton variant="text" width="60%" height={20} />
        <div className="mt-2 flex flex-col gap-2">
          <Skeleton variant="text" width="100%" />
          <Skeleton variant="text" width="80%" />
        </div>
      </div>

      {/* 矢印 */}
      <div className="shrink-0 pt-1">
        <Skeleton variant="circle" width={24} />
      </div>
    </div>
  )
}
